import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../contexts/SnackbarContext';

type FetchOptions = RequestInit & {
    skipAuth?: boolean;
};

export function useAuthenticatedFetch() {
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    async function authenticatedFetch(
        url: string,
        options: FetchOptions = {}
    ): Promise<Response> {
        const { skipAuth = false, headers = {}, ...rest } = options;

        const token = localStorage.getItem('token');

        const finalHeaders = {
            ...headers,
            ...(token && !skipAuth ? { 'Authorization': `Bearer ${token}` } : {}),
        };

        try {
            const response = await fetch(url, {
                ...rest,
                headers: finalHeaders,
            });

            if (response.status === 401 && !skipAuth) {
                localStorage.removeItem('token');
                showSnackbar('Session expired. Please login again.', 'error');
                setTimeout(() => navigate('/'), 1000);
            }

            return response;
        } catch (error) {
            console.error('Fetch error:', error);
            throw error;
        }
    }

    return authenticatedFetch;
}